export const UPDATE_PERIOD = 250;

export const CUE_ACTION = {
  DISPLAYED: 'text_displayed',
  REMOVED: 'text_removed',
};

export const TEXT_RENDERER_V3 = 3;

export const TEXT_RENDERER_V4 = 4;
